// src/hocs/withAdminActionLogger.js
import React from "react";
import api from "../services/apiServices"; // Your API client

const withAdminActionLogger = (WrappedComponent) => {
  return (props) => {
    const logAction = async (action, details) => {
      try {
        await api.post("/audit/log-action", { action, details });
      } catch (error) {
        console.error("Failed to log action:", error);
      }
    };

    return <WrappedComponent {...props} logAction={logAction} />;
  };
};

export default withAdminActionLogger;
